import { Box, Spinner } from '@careflux/primitives';

/** Full-screen spinner shown by route guards while checking or redirecting. */
export const GuardSpinner = () => (
  <Box display="flex" align="center" justify="center" height="screen" background="background">
    <Spinner size="lg" label="Hleð..." />
  </Box>
);
